import React from 'react';
import { Box, Stack, Grid, useTheme, useMediaQuery, Skeleton } from '@mui/material';
import GridItems from '../components/GridItems';
import { SliderValue } from 'common/modules/customization';
import { range } from 'lodash';

export interface Props {
	gridColumns: SliderValue | undefined;
}

const ProductListingView = (props: Props) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('md'));
	const { gridColumns } = props;
	return (
		<>
			{!isMobile && (
				<Stack mr={2}>
					{range(8).map((_, i) => (
						<Box mb={2} key={i}>
							<Skeleton animation={false} width={150} />
						</Box>
					))}
				</Stack>
			)}
			<Grid ml={!isMobile ? 2 : undefined} container spacing={2}>
				<GridItems gridColumns={gridColumns} />
			</Grid>
		</>
	);
};

export default ProductListingView;
